import { render, staticRenderFns } from "./DisableDisbursalModal.vue?vue&type=template&id=e45997aa&"
import script from "./DisableDisbursalModal.vue?vue&type=script&lang=js&"
export * from "./DisableDisbursalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports